import { ChainId } from '@src/configs/chainInfo'

// Quote refresh timing constants
export const QUOTE_REFRESH_INTERVAL = 60000 // 60 seconds
export const QUOTE_REFRESH_BUFFER = 30000 // 30 seconds before expiration to refresh
export const MIN_AMOUNT = 0.02
export const THRESHOLD_TO_SEND_TO_CCTP = 1000
export const MAX_SELL_AMOUNT = 15000

// BigNumber configuration
export const BIGNUMBER_EXPONENTIAL_AT = 1e9

// UI size constants
export const TOKEN_ICON_SIZE = 40
export const CHAIN_ICON_SIZE = 16

// Tooltip text constants
export const UNWRAPPED_TOKEN_TOOLTIP =
    'You will be prompted to sign a request to convert your gas token into its wrapped token equivalent after you initiate the swap'
export const CCTP_TOOLTIP =
    'This is a CCTP (Cross-Chain Transfer Protocol) transfer. CCTP transfers require block confirmations which may take several minutes depending on the chains involved.'
export const POINTS_DETAIL_TOOLTIP = 'Click here to learn more'

// Debounce delays
export const QUOTE_DEBOUNCE_DELAY = 800

// Screen size breakpoints
export const LARGE_SCREEN_THRESHOLD = 600

export const MAX_COMPUTE_UNITS = BigInt(2 ** 64 - 1)

// These multiplier values are empirically determined based on
// metamask estimates and QA tests.
export const NATIVE_SETMAX_BUFFER_MULTIPLIERS: Record<number, bigint> = {
    [ChainId.Ethereum]: BigInt(2),
    [ChainId.Unichain]: BigInt(1000),
    [ChainId.Polygon]: BigInt(200),
    [ChainId.Base]: BigInt(50),
    [ChainId.Arbitrum]: BigInt(50),
    [ChainId.Celo]: BigInt(20),
}

export const NATIVE_SETMAX_BUFFER_MULTIPLIER_DEFAULT = BigInt(5)

export const MAX_TOKEN_DISPLAY_DECIMALS = 7
